<script>
import LoadingSpinner from "../../../components/LoadingSpinner.vue";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      image: null,
    };
  },
  components: {
    LoadingSpinner,
  },
  props: {
    selectedSurveyID: null,
  },
  mounted() {
    this.getWordFromLink();
  },
  methods: {
    ...mapActions("results", ["wordCloud"]),
    getWordFromLink() {
      let params = {
        is_deleted: false,
        su1_survey_id: this.selectedSurveyID,
        su2_survey_id: this.selectedSurveyID,
        survey_type: "su2",
      };
      this.wordCloud(params)
        .then((response) => {
          const blob = response.data;
          const fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onloadend = () => {
            this.image = fileReader.result;
          }
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
  },
};
</script>

<template>
  <div class="image-container">
    <img v-if="image" :src="image" alt="wordcloud">
    <loading-spinner v-else class="__loading"/>
  </div>
</template>

<style scoped lang="scss">
.__loading {
  scale: 2;
}

.image-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 3em;
}

img {
  width: 100%;
  height: 100%;
}
</style>
